<template>
    <div id="pt_also_like" class="pt_also_like">
        <h2>You may also like</h2>
        
        <div class="tab" v-if="hasRelated && hasRecommend">
            <div class="premium-tab active">Related Products</div>
            <div class="premium-tab ">Our Recommendations</div>
        </div>

        <div class="tab-content-also">
            <div class="tab-content-insider" >
                <section class="related products">
                    <div class="custom_insider"  id="custom_insider" >
                        <!-- Show Related Products -->
                        <div v-if="hasRelated" class="ins-sr-api-wrapper tab_related" :class="`ins-preview-wrapper-` +   insiderCampaignDataRelated.variationId">
                            <div class="custom_data_insider " :class="isMobile ? 'ins-mobile-web-smart-recommender-body' : 'ins-web-smart-recommender-body'">
                                <listingProductInsider
                                    :loop="false" 
                                    :dataListing="insiderCampaignDataRelated?.products"
                                    :modules="modules" 
                                    :slidesPerView="5" 
                                    :slidesPerGroup="1" 
                                    :breakpoints="swiperBreakpointsInsider"
                                    :parentId="`insider_related_crousel`" 
                                    :campaignId = "insiderCampaignDataRelated?.campaignId"
                                    :variationId = "insiderCampaignDataRelated?.variationId"
                                />
                            </div>
                        </div>
                        <!-- Show Recommendations -->
                        <div v-if="hasRecommend" class="ins-sr-api-wrapper tab_recommend" :class="`ins-preview-wrapper-` +   insiderCampaignDataRecommend.variationId">
                            <div class="custom_data_insider " :class="isMobile ? 'ins-mobile-web-smart-recommender-body' : 'ins-web-smart-recommender-body'">
                                <listingProductInsider
                                    :loop="false" 
                                    :dataListing="insiderCampaignDataRecommend?.products"
                                    :modules="modules" 
                                    :slidesPerView="5" 
                                    :slidesPerGroup="1" 
                                    :breakpoints="swiperBreakpointsInsider"
                                    :parentId="`insider_recommend_crousel`" 
                                    :campaignId = "insiderCampaignDataRecommend?.campaignId"
                                    :variationId = "insiderCampaignDataRecommend?.variationId"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_unboxcarousel.scss";
</style>

<script setup lang="ts">
    import { onMounted, computed, nextTick } from "vue"
    import { Navigation, Pagination } from "swiper/modules";
    import listingProductInsider from '~/components/Product/CarouselProductInsider.vue';

    const isMobile = ref(false);
    const swiperBreakpointsInsider = {
        320: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 8,
        },
    };

    const insiderCampaignDataRelated = ref({});
    const insiderCampaignDataRecommend = ref({});

    const props = defineProps(["recommendation", "related"]);

    // Computed properties to check if data exists
    const hasRelated = computed(() => {
        return insiderCampaignDataRelated.value?.products && insiderCampaignDataRelated.value.products.length > 0;
    });

    const hasRecommend = computed(() => {
        return insiderCampaignDataRecommend.value?.products && insiderCampaignDataRecommend.value.products.length > 0;
    });

    const setupTabHandlers = async () => {
        await nextTick();
        const tabs = document.querySelectorAll('.pt_also_like .premium-tab');
        const tabRelated = document.querySelector('.tab_related');
        const tabRecommend = document.querySelector('.tab_recommend');

        // Set default: first tab (Related Products) is active
        if (tabs.length > 0) {
            tabs[0].classList.add('active');
        }
        if (tabRelated) {
            tabRelated.style.display = 'block';
        }
        if (tabRecommend) {
            tabRecommend.style.display = 'none';
        }

        // Remove previous listeners to avoid duplicates
        for (let i = 0; i < tabs.length; i++) {
            const oldListener = tabs[i].onclick;
            if (oldListener) {
                tabs[i].removeEventListener('click', oldListener as any);
            }
        }

        // Add click listeners
        for (let i = 0; i < tabs.length; i++) {
            tabs[i].addEventListener('click', function() {
                // Remove active class from all tabs
                for (let j = 0; j < tabs.length; j++) {
                    tabs[j].classList.remove('active');
                }
                
                if (tabRelated) tabRelated.style.display = 'none';
                if (tabRecommend) tabRecommend.style.display = 'none';

                tabs[i].classList.add('active');

                if (i === 0) {
                    // Related Products tab clicked
                    if (tabRelated) tabRelated.style.display = 'block';
                } else if (i === 1) {
                    // Recommendations tab clicked
                    if (tabRecommend) tabRecommend.style.display = 'block';
                }
                
                // Re-calculate button positions for both carousels after tab switch
                setTimeout(() => {
                    window.dispatchEvent(new Event('recalculateButtonPosition'));
                }, 100);
            });
        }
    };

    watch(() => props.recommendation, async (recommendationData) => {
        insiderCampaignDataRelated.value = recommendationData;
        if (hasRelated.value && hasRecommend.value) {
            await setupTabHandlers();
        }
    }, { immediate: true });

    watch(() => props.related, async (relatedData) => {
        insiderCampaignDataRecommend.value = relatedData;
        if (hasRelated.value && hasRecommend.value) {
            await setupTabHandlers();
        }
    }, { immediate: true });

    const swiperBreakpoints = {
        320: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 8,
        },
    };
    const navigation = ref(true);
    const modules = [Navigation];
    const checkIsMobile = () => {
        const screenWidth = window.innerWidth;
        isMobile.value = screenWidth <= 768;
    };

    onMounted(() => {
        // const screenWidth = window.innerWidth;
        // if(screenWidth <= 768){
        //     isMobile.value = true;
        // }
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
    })
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/components/product/_product.scss";
   @import "@/assets/scss/components/listing/listingItem.scss";
   .tab-content-also{
        .tab-content-insider{
            
            .products {
                max-width: 1440px;
                margin: 0;
                margin-left: auto;
                margin-right: auto;
                padding-left: 15px;
                padding-right: 15px;
                @media (max-width: 768px) {
                    padding: 0;
                }
                .box-controls{
                    // display: none;
                    @media (max-width: 768px) {
                        display: block;
                    }
                }
                .splide:not(.is-initialized) {
                    visibility: visible;
                }
                li{
                    margin-bottom: 30px;
                    transition: all .3s ease-out;
                    margin-top: 15px;
                    width: calc(20% - 8px);
                    margin-right: 5px;
                    margin-left: 5px;
                    &:first-child {
                        margin-left: 0;
                    }
                    &:hover{
                        background-color: #FFFFFF;
                        // box-shadow: 0 23px 23px 0 rgba(92, 92, 92, 0.2);
                        box-shadow: 0 5px 10px 2px #0000001A !important;
                        .imagewrapper{
                            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.0) !important;
                        }
                    }

                    .imagewrapper {
                        border: none !important;
                        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
                        position: relative;
                        &:hover{
                            .product-thumbnail-hover{
                                opacity: 1;
                                visibility: visible;
                            }
                        }
                        img, video{
                            width : 100%;
                        }
                        .woocommerce-product-gallery__video, .product-thumbnail-hover {
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            padding-top: 0;

                        }
                        .product-thumbnail-hover{
                            visibility: hidden;
                        }
                        .tinv-wraper.tinv-wishlist {
                            position: absolute;
                            bottom: 5px;
                            right: 0;
                            z-index: 10;
                            .no-txt:hover{
                                background-image: url('https://skjewellery396.e.wpstage.net/wp-content/themes/SKSG8.5.0/images/single-product/like_icon_hover.png');
                                background-repeat: no-repeat;
                                height: 30px;
                                width: 30px;
                                margin: 0 auto;
                                cursor: pointer;
                            }
                            .no-txt {
                                margin: 0;
                                height: 30px;
                                width: 30px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                /* background-color: #9D9D9D; */
                                border-radius: 50%;
                                background-image: url('https://skjewellery396.e.wpstage.net/wp-content/themes/SKSG8.5.0/images/single-product/like_icon.png');
                                background-size: 16px;
                                background-repeat: no-repeat;
                                background-position: center;
                                cursor: pointer;
                                > img{
                                    display: none !important;
                                }
                            }
                        }
                    }
                    
                    .wapper_shop_item{
                        border: none;
                        padding: 20px 10px;
                        display: block;
                        text-align: center;
                        .woocommerce-loop-product__title{
                            padding : 0 !important;
                            margin-bottom: 5px !important;
                            margin-top: 0!important;
                            a{
                                color: #212529;
                                font-size: 16px;
                                font-weight: 400;
                                text-transform: capitalize;
                                line-height: 19px;
                            }
                        }
                        .price {
                            font-size: 16px !important;
                            font-weight: 600 !important;
                            color: #212529 !important;
                            margin-bottom: 0;
                            del{
                                font-size: 16px !important;
                                color: #999;
                                opacity: 1 !important;
                            }
                        }
                    }
                }
            }
        }
    }
</style>